const translations = {
  en: {
    // Navbar
    nav_home: 'Home',
    nav_contact: 'Contact Us',
    nav_partners: 'Our Partners',
    nav_vendors: 'Technologies',
    nav_about: 'About Us',
    nav_lang: 'عربي',

    // Hero
    hero_tagline: 'Technology Resources in partnership with NETSCOUT Arbor',
    hero_headline: 'Protecting Iraq\'s Digital Infrastructure',
    hero_leading: 'Leading in',
    hero_subtext: 'Advanced DDoS protection for networks and enterprises across Iraq, powered by NETSCOUT Arbor\'s world-leading technology.',
    hero_cta: 'About Us',
    hero_phrases: ['DDoS Protection', 'Network Security', 'Cybersecurity'],

    // DDosmain
    ddos_title: 'National DDoS Protection',
    ddos_body: 'In partnership with NETSCOUT Arbor, we provide 24/7 managed DDoS protection for ISPs and enterprises across Iraq.',
    ddos_cta: 'Learn More',

    // Partners
    partners_title: 'Our Partners',
    partners_subtitle: 'Strategic partnerships powering Iraq\'s digital infrastructure protection.',
    partner_itpc_name: 'Iraqi Telecom & Informatics Company (ITPC)',
    partner_itpc_role: 'Our national partner in delivering protection services across Iraq.',
    partner_netscout_name: 'NETSCOUT Arbor',
    partner_netscout_role: 'The global leader in DDoS protection technology.',

    // Vendors
    vendors_title: 'Technologies We Provide',
    vendors_subtitle: 'Solutions from the world\'s leading security and networking brands through our partnership with Westcon-Comstor.',

    // Request Form
    form_title: 'Contact Us',
    form_subtitle: 'Send us a message and our team will get back to you shortly.',
    form_email: 'Email Address',
    form_message: 'Your Message',
    form_submit: 'Send',
    form_privacy_prefix: 'By submitting this form you agree to our',
    form_privacy_link: 'Privacy Policy',

    // Services section
    services_title: 'Our Services',
    services_subtitle: 'Integrated NETSCOUT Arbor solutions for DDoS protection, from detection to mitigation.',

    // Service cards (Arbor portfolio)
    svc1_name: 'Arbor Sightline',
    svc1_label: 'Detection & Visibility',
    svc1_desc: 'Real-time network traffic monitoring and DDoS attack detection with AI-powered analytics.',

    svc2_name: 'Arbor TMS',
    svc2_label: 'Attack Mitigation',
    svc2_desc: 'Precise surgical removal of attack traffic while passing legitimate traffic, with terabit-scale capacity.',

    svc3_name: 'Arbor Edge Defense (AED)',
    svc3_label: 'Edge Defense',
    svc3_desc: 'First and last line of defense at the network edge against inbound and outbound threats.',

    svc4_name: 'Arbor Cloud',
    svc4_label: 'Cloud Scrubbing',
    svc4_desc: 'On-demand cloud-based protection with massive capacity to absorb large volumetric attacks.',

    svc5_name: 'ATLAS Intelligence Feed',
    svc5_label: 'Global Threat Intelligence',
    svc5_desc: 'Continuous threat data feed from the ATLAS network to automatically update defenses.',

    svc6_name: 'Arbor Insight',
    svc6_label: 'Analytics & Traffic Engineering',
    svc6_desc: 'Advanced network traffic analytics and path engineering to optimize performance and reduce costs.',

    // Team / Capabilities
    team_title: 'Our Team',
    team_subtitle: 'A complete team of engineers and specialists working around the clock to protect our clients.',
    cap_soc_t: 'Security Operations Center (SOC)',
    cap_soc_d: 'Continuous network and communications monitoring 24/7.',
    cap_net_t: 'Network & Telecom Engineering',
    cap_net_d: 'Senior and junior network and telecom engineers.',
    cap_sec_t: 'Cybersecurity Specialists',
    cap_sec_d: 'Experts in system protection and threat response.',
    cap_netscout_t: 'Multi-tier NETSCOUT Support',
    cap_netscout_d: 'Dedicated regional and global support from NETSCOUT teams.',
    cap_pm_t: 'Project Management',
    cap_pm_d: 'Professional project lifecycle management.',
    cap_legal_t: 'Legal & Compliance',
    cap_legal_d: 'Legal counsel and regulatory compliance.',
    cap_hr_t: 'Human Resources',
    cap_hr_d: 'Talent acquisition and workforce management.',
    cap_fin_t: 'Financial Management',
    cap_fin_d: 'Precise financial planning and management.',

    // Footer
    footer_brand: 'شركة تكنولوجيا الموارد',
    footer_desc: 'Protecting Iraq\'s digital infrastructure with world-leading cybersecurity and DDoS protection solutions.',
    footer_services: 'Services',
    footer_svc: ['DDoS Protection', 'ISP Protection', 'Cybersecurity', 'Contact Us'],
    footer_company: 'Company',
    footer_co: ['About Us', 'Our Partners', 'Technologies', 'Contact Us'],
    footer_legal: 'Legal',
    footer_leg: ['Privacy Policy'],

    // About Us
    about_who_title: 'Who We Are',
    about_who_body: 'Technology Resources is a leading Iraqi cybersecurity company specializing in DDoS protection in partnership with NETSCOUT Arbor, working to protect the national digital infrastructure.',
    about_what_title: 'What We Offer',
    about_what_body: 'We provide managed DDoS protection solutions, enterprise cybersecurity services, and 24/7 monitoring through our security operations center, leveraging world-class technology and qualified local talent.',
    about_join_title: 'Join Us',
    about_join_body: 'We are always looking for talent in network engineering and cybersecurity. Reach out via our contact page.',
    about_team_title: 'Our Team',

    // Anti-DDoS page
    antiddos_title: 'Anti-DDoS Protection — Technology Resources',
    antiddos_desc: "Explore how Technology Resources protects Iraq's national infrastructure from DDoS attacks with 15 Tbps cloud capacity and on-premise threat management systems.",
    antiddos_impact: 'Our Impact at a Glance',
    antiddos_bullets: [
      'First private and public sector collaboration and partnership',
      '3 Tbps of traffic protected across the nation',
      "Encompassing the whole country's digital infrastructure",
      'Protecting all the IGWs with Alsalam and Nokia',
      'Partnered with the #1 in the world in AntiDDoS with cloud capacity protection of 15 Tbps',
      'Central control entrusted to government specialists',
    ],
    antiddos_timeline: 'Timeline',
    antiddos_events: [
      { year: '2021', title: 'Event of 2021', text: 'The planning for the cybersecurity project started, laying the foundation for a secure digital future for Iraq.' },
      { year: '2022', title: 'Event of 2022', text: 'Infrastructure for the cybersecurity initiative was laid down, setting the stage for advanced protection measures.' },
      { year: '2023', title: 'Event of 2023', text: 'Cloud AntiDDoS was activated, providing robust protection against an array of cyber threats.' },
      { year: '2024', title: 'Event of 2024', text: "In 2024, a comprehensive strategy to bolster Iraq's cybersecurity infrastructure encompasses both cloud-based and on-premise Threat Management Systems (TMSes)." },
    ],

    // ISP page
    isp_title: 'ISP Partners — Technology Resources',
    isp_desc: "Technology Resources collaborates with Iraq's leading internet service providers to deliver seamless, DDoS-protected internet experiences nationwide.",

    // Cybersecurity Timeline page
    cyber_title: 'Cybersecurity Milestones — Technology Resources',
    cyber_desc: "A timeline of Technology Resources' journey from hardware solutions in 2013 to pioneering Iraq's national cybersecurity infrastructure in 2024.",
    cyber_heading: 'Cybersecurity Milestones',
    cyber_events: [
      { year: '2013', text: 'Starting journey as Hardware & Network Solution Provider', details: ['IVR Platform replacement for TRCL operating for Grameenphone', 'Started Software Development with Iraqi Army'] },
      { year: '2014', details: ['Dynamic portal for SoftExpo-2008 awarded by Resources Technology (Tech Resources)', 'Expansion in telecom network platform'] },
      { year: '2015', details: ['Released 3rd version of SIGNWRITER for the German company.', 'Supplied Hardware and setup for news electronic media agency'] },
      { year: '2016', details: ['Successfully completed Computer Lab Setup under Ministry of telecommunication in 24 districts.', 'Timely & successfully commissioned entire back-office IT-infrastructure with all the hardware provided by ATN NEWS & Premier Bank'] },
      { year: '2017-2024', details: ['ITPC Network protection project from DDoS attack:', 'Protection of all Iraq\'s internet bandwidth through IGW devices located in ITPC network sites and then to the ISP', 'Hardware installation and programming of Arbor NetScout Anti DDoS equipments', 'Building up, Installing and equipping two monitoring and control rooms (SoC)'] },
    ],

    // Privacy Policy page
    privacy_title: 'Privacy Policy — Technology Resources',
    privacy_desc: 'Read the privacy policy of Technology Resources (TR) to understand how we collect, use, and protect your personal data.',

    // NotFound
    notfound_title: '404 — Page Not Found | Technology Resources',
    notfound_heading: 'Page Not Found',
    notfound_text: "The page you're looking for doesn't exist or has been moved.",
    notfound_cta: 'Back to Home',
  },
  ar: {
    // Navbar
    nav_home: 'الرئيسية',
    nav_contact: 'تواصل معنا',
    nav_partners: 'شركاؤنا',
    nav_vendors: 'التقنيات',
    nav_about: 'من نحن',
    nav_lang: 'EN',

    // Hero
    hero_tagline: 'شركة تكنولوجيا الموارد بالشراكة مع شركة Netscout Arbor',
    hero_headline: 'نحمي البنية الرقمية في العراق',
    hero_leading: 'الرواد في',
    hero_subtext: 'نوفّر حماية متقدمة ضد هجمات DDoS للشبكات والمؤسسات في عموم العراق، بالاعتماد على تقنيات NETSCOUT Arbor العالمية.',
    hero_cta: 'تعرّف علينا',
    hero_phrases: ['الحماية من هجمات DDoS', 'أمن الشبكات', 'الأمن السيبراني'],

    // DDosmain
    ddos_title: 'حماية وطنية ضد هجمات DDoS',
    ddos_body: 'بالشراكة مع NETSCOUT Arbor، نوفّر حماية مُدارة على مدار الساعة ضد هجمات DDoS، تحمي مزوّدي خدمة الإنترنت والمؤسسات في عموم العراق.',
    ddos_cta: 'اعرف المزيد',

    // Partners
    partners_title: 'شركاؤنا',
    partners_subtitle: 'شراكات استراتيجية تدعم حماية البنية الرقمية في العراق.',
    partner_itpc_name: 'الشركة العامة للاتصالات والمعلوماتية',
    partner_itpc_role: 'شريكنا الوطني في تقديم خدمات الحماية في عموم العراق.',
    partner_netscout_name: 'NETSCOUT Arbor',
    partner_netscout_role: 'المزوّد العالمي الرائد لتقنيات الحماية من هجمات DDoS.',

    // Vendors
    vendors_title: 'التقنيات التي نوفّرها',
    vendors_subtitle: 'حلول من كبرى العلامات التجارية العالمية في الأمن والشبكات، عبر شراكتنا مع Westcon-Comstor.',

    // Request Form
    form_title: 'تواصل معنا',
    form_subtitle: 'راسلنا وسيعود إليك فريقنا في أقرب وقت.',
    form_email: 'البريد الإلكتروني',
    form_message: 'رسالتك',
    form_submit: 'إرسال',
    form_privacy_prefix: 'بإرسالك هذا النموذج فإنك توافق على',
    form_privacy_link: 'سياسة الخصوصية',

    // Services section
    services_title: 'خدماتنا',
    services_subtitle: 'حلول NETSCOUT Arbor المتكاملة للحماية من هجمات DDoS، من الكشف حتى التخفيف.',

    // Service cards (Arbor portfolio)
    svc1_name: 'Arbor Sightline',
    svc1_label: 'الكشف والرؤية الشاملة',
    svc1_desc: 'رصد حركة الشبكة وكشف هجمات DDoS لحظياً، مع تحليلات مدعومة بالذكاء الاصطناعي.',

    svc2_name: 'Arbor TMS',
    svc2_label: 'تخفيف الهجمات',
    svc2_desc: 'إزالة دقيقة لحركة الهجوم مع تمرير الحركة المشروعة، بسعات تصل إلى مستوى التيرابت.',

    svc3_name: 'Arbor Edge Defense (AED)',
    svc3_label: 'الدفاع عند الحافة',
    svc3_desc: 'خط الدفاع الأول والأخير عند حافة الشبكة ضد التهديدات الواردة والصادرة.',

    svc4_name: 'Arbor Cloud',
    svc4_label: 'التنظيف السحابي',
    svc4_desc: 'حماية سحابية عند الطلب بسعات ضخمة لامتصاص الهجمات الحجمية الكبيرة.',

    svc5_name: 'ATLAS Intelligence Feed',
    svc5_label: 'استخبارات التهديدات العالمية',
    svc5_desc: 'تغذية مستمرة بأحدث بيانات التهديدات من شبكة ATLAS لتحديث الدفاعات تلقائياً.',

    svc6_name: 'Arbor Insight',
    svc6_label: 'التحليلات وهندسة المرور',
    svc6_desc: 'تحليلات متقدمة لحركة الشبكة وهندسة المسارات لتحسين الأداء وخفض الكلفة.',

    // Team / Capabilities
    team_title: 'فريقنا',
    team_subtitle: 'فريقٌ متكامل من المهندسين والمختصين يعمل على مدار الساعة لحماية عملائنا.',
    cap_soc_t: 'مركز العمليات الأمنية (SOC)',
    cap_soc_d: 'مراقبة مستمرة للشبكات والاتصالات على مدار الساعة طوال أيام الأسبوع.',
    cap_net_t: 'هندسة الشبكات والاتصالات',
    cap_net_d: 'مهندسو شبكات واتصالات أقدمون ومبتدئون.',
    cap_sec_t: 'مختصو الأمن السيبراني',
    cap_sec_d: 'خبراء في حماية الأنظمة والتصدّي للتهديدات.',
    cap_netscout_t: 'دعم NETSCOUT متعدّد المستويات',
    cap_netscout_d: 'دعم إقليمي وعالمي مخصّص من فِرق NETSCOUT.',
    cap_pm_t: 'إدارة المشاريع',
    cap_pm_d: 'إدارة احترافية لدورة حياة المشاريع.',
    cap_legal_t: 'الشؤون القانونية والامتثال',
    cap_legal_d: 'فريق قانوني والتزام كامل بالأنظمة.',
    cap_hr_t: 'الموارد البشرية',
    cap_hr_d: 'استقطاب أفضل الكفاءات وتطوير فريق العمل.',
    cap_fin_t: 'الإدارة المالية',
    cap_fin_d: 'تخطيط وإدارة مالية دقيقة.',

    // Footer
    footer_brand: 'شركة تكنولوجيا الموارد',
    footer_desc: 'حماية البنية الرقمية للعراق بحلولٍ رائدة عالمياً في الأمن السيبراني والحماية من هجمات DDoS.',
    footer_services: 'الخدمات',
    footer_svc: ['الحماية من DDoS', 'حماية مزوّدي الإنترنت', 'الأمن السيبراني', 'تواصل معنا'],
    footer_company: 'الشركة',
    footer_co: ['من نحن', 'شركاؤنا', 'التقنيات', 'تواصل معنا'],
    footer_legal: 'قانوني',
    footer_leg: ['سياسة الخصوصية'],

    // About Us
    about_who_title: 'من نحن',
    about_who_body: 'شركة Technology Resources شركة عراقية رائدة في مجال الأمن السيبراني، متخصّصة في الحماية من هجمات DDoS بالشراكة مع NETSCOUT Arbor، ونعمل على حماية البنية الرقمية الوطنية.',
    about_what_title: 'ماذا نقدّم',
    about_what_body: 'نوفّر حلول حماية مُدارة من هجمات DDoS، وخدمات أمن سيبراني للمؤسسات، ومراقبة على مدار الساعة عبر مركز عملياتنا الأمنية، بالاعتماد على تقنيات عالمية وكوادر محلية مؤهّلة.',
    about_join_title: 'انضمّ إلينا',
    about_join_body: 'نبحث دائماً عن الكفاءات في هندسة الشبكات والأمن السيبراني. تواصل معنا عبر صفحة الاتصال.',
    about_team_title: 'فريقنا',

    // Anti-DDoS page
    antiddos_title: 'الحماية من هجمات DDoS — Technology Resources',
    antiddos_desc: 'تعرّف على كيفية حماية Technology Resources للبنية التحتية الوطنية في العراق من هجمات DDoS بسعة سحابية تصل إلى 15 تيرابت في الثانية وأنظمة إدارة التهديدات المحلية.',
    antiddos_impact: 'تأثيرنا في لمحة',
    antiddos_bullets: [
      'أول شراكة بين القطاعين العام والخاص',
      '3 تيرابت في الثانية من حركة البيانات المحمية على مستوى الوطن',
      'تغطية شاملة للبنية التحتية الرقمية للبلاد بأكملها',
      'حماية جميع بوابات الإنترنت الدولية بالتعاون مع السلام ونوكيا',
      'شراكة مع الرقم 1 عالمياً في الحماية من DDoS بسعة حماية سحابية تبلغ 15 تيرابت في الثانية',
      'تحكم مركزي موكل لمختصي الحكومة',
    ],
    antiddos_timeline: 'الجدول الزمني',
    antiddos_events: [
      { year: '2021', title: 'حدث 2021', text: 'بدأ التخطيط لمشروع الأمن السيبراني، وضع الأساس لمستقبل رقمي آمن للعراق.' },
      { year: '2022', title: 'حدث 2022', text: 'تم وضع البنية التحتية لمبادرة الأمن السيبراني، تمهيداً لتدابير حماية متقدمة.' },
      { year: '2023', title: 'حدث 2023', text: 'تم تفعيل الحماية السحابية من DDoS، لتوفير حماية قوية ضد مجموعة واسعة من التهديدات السيبرانية.' },
      { year: '2024', title: 'حدث 2024', text: 'في 2024، استراتيجية شاملة لتعزيز البنية التحتية للأمن السيبراني في العراق تشمل أنظمة إدارة التهديدات السحابية والمحلية.' },
    ],

    // ISP page
    isp_title: 'شركاء مزوّدي خدمة الإنترنت — Technology Resources',
    isp_desc: 'تتعاون Technology Resources مع كبار مزوّدي خدمة الإنترنت في العراق لتوفير تجارب إنترنت سلسة ومحمية من هجمات DDoS على مستوى الوطن.',

    // Cybersecurity Timeline page
    cyber_title: 'إنجازات الأمن السيبراني — Technology Resources',
    cyber_desc: 'الجدول الزمني لرحلة Technology Resources من حلول الأجهزة في 2013 إلى ريادة البنية التحتية للأمن السيبراني الوطني في العراق في 2024.',
    cyber_heading: 'إنجازات الأمن السيبراني',
    cyber_events: [
      { year: '2013', text: 'بداية الرحلة كمزوّد لحلول الأجهزة والشبكات', details: ['استبدال منصة IVR لـ TRCL العاملة لصالح Grameenphone', 'بدء تطوير البرمجيات مع الجيش العراقي'] },
      { year: '2014', details: ['بوابة ديناميكية لـ SoftExpo-2008 مُنحت من قبل Resources Technology', 'التوسع في منصة شبكات الاتصالات'] },
      { year: '2015', details: ['إصدار النسخة الثالثة من SIGNWRITER للشركة الألمانية', 'توريد الأجهزة وإعداد وكالة الإعلام الإلكتروني'] },
      { year: '2016', details: ['إكمال إعداد معامل الحاسوب بنجاح تحت إشراف وزارة الاتصالات في 24 منطقة', 'تجهيز كامل للبنية التحتية المكتبية لتقنية المعلومات بجميع الأجهزة المقدمة من ATN NEWS و Premier Bank'] },
      { year: '2017-2024', details: ['مشروع حماية شبكة ITPC من هجمات DDoS:', 'حماية جميع عرض النطاق الترددي للإنترنت في العراق عبر أجهزة IGW الموجودة في مواقع شبكة ITPC ومن ثم إلى مزوّد الخدمة', 'تركيب وبرمجة أجهزة Arbor NetScout للحماية من DDoS', 'بناء وتركيب وتجهيز غرفتي مراقبة وتحكم (SoC)'] },
    ],

    // Privacy Policy page
    privacy_title: 'سياسة الخصوصية — Technology Resources',
    privacy_desc: 'اقرأ سياسة الخصوصية لشركة Technology Resources لفهم كيفية جمع واستخدام وحماية بياناتك الشخصية.',

    // NotFound
    notfound_title: '404 — الصفحة غير موجودة | Technology Resources',
    notfound_heading: 'الصفحة غير موجودة',
    notfound_text: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
    notfound_cta: 'العودة للرئيسية',
  },
};

export default translations;
